import { render, staticRenderFns } from "./ForwarderFilter.vue?vue&type=template&id=281c6f82"
import script from "./ForwarderFilter.vue?vue&type=script&lang=js"
export * from "./ForwarderFilter.vue?vue&type=script&lang=js"
import style0 from "./ForwarderFilter.vue?vue&type=style&index=0&id=281c6f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports